import styled from 'styled-components';

// DetailLayoutContent itself never pads - a full-bleed child (e.g. a tabs
// nav bar) can span its whole width. This is the padding a consumer wraps
// its own non-full-bleed body content in instead.
export const DETAIL_LAYOUT_CONTENT_PADDING = 40;

export const DetailLayoutWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: hidden;
`;

export const DetailLayoutContent = styled.div<{ $selfScrolling?: boolean }>`
  width: 100%;
  box-sizing: border-box;
  flex: 1;
  min-height: 0;

  ${({ $selfScrolling }) =>
    $selfScrolling
      ? `
    overflow: hidden;
    display: flex;
    flex-direction: column;
  `
      : `
    overflow: auto;
  `}
`;

export const DetailLayoutLoadingContainer = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const DetailLayoutFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  width: 100%;
  box-sizing: border-box;
  flex-shrink: 0;
  padding: 12px 24px;
  border-top: 1px solid var(--light-pink);
  box-shadow: 0 -2px 8px rgba(35, 37, 103, 0.08);

  /* The design system's disabled primary button is white text on
     --light-pink, which all but disappears against this footer. */
  .custom-btn.ant-btn-default.primary:disabled {
    color: var(--dark-gray);
    background: var(--dark-background);
    border-color: var(--gray);
    opacity: 0.8;
  }
`;
